












































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import Content from '@/dex-shared/components/new_content/Content.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import EssaySheet from '@/components/EssaySheet.vue';
import { fileUploadURL } from '@/dex-shared/settings/endpoints';
import SubjectModel from '@/models/SubjectModel';

export default Vue.extend({
  components: {
    Content,
    pxButton,
    EssaySheet,
    Loading,
  },
  data() {
    return {
      sent: false,
    };
  },
  computed: {
    ...mapGetters({
      subjectBySlug: 'subjectBySlug',
    }),
    subject(): SubjectModel {
      return this.subjectBySlug(this.$route.params.subjectSlug);
    },
  },
  methods: {
    essayWasSent() {
      this.sent = true;
    },
  },
});
